import * as api from '../api'

export const askQuestion = (questionData,navigate) => async (dispatch)=>{
    try {
        console.log(questionData);
        const {data} = await api.postQuestion(questionData)
        dispatch({
            type:"POST_QUESTION",
            payload:data
        })
        dispatch(fetchAllQuestions())
        navigate('/')
    } catch (error) {
        console.log(error)
    }
}

export const fetchAllQuestions = () => async (dispatch)=>{
    try {
        const {data}= await api.getAllQuestions()
        dispatch({type:"FETCH_ALL_QUESTIONS",payload:data})
    } catch (error) {
        console.log(error)
    }
}

export const postAnswer = (answerData)=>async (dispatch)=>{
    try {
        const {id,noOfAnswers,answerBody,userAnswered,userId}=answerData;
        const {data}=await api.postAnswer(id,noOfAnswers,answerBody,userAnswered,userId)
        dispatch({type:"POST_ANSWER",payload:data})
        dispatch(fetchAllQuestions())
    } catch (error) {
        console.log(error);
    }
}

export const deleteQuestion = (id,navigate)=> async (dispatch)=>{
    try {
        console.log(id);
        const {data}=await api.deleteQuestion(id);
        
        dispatch(fetchAllQuestions())
        navigate('/')
    } catch (error) {
        console.log(error);
    }
}

export const deleteAnswer = (id,answerId,noOfAnswers)=> async (dispatch)=>{
    try {
        console.log({id,answerId,noOfAnswers})
        const {data}=await api.deleteAnswer(id,answerId,noOfAnswers)
        dispatch(fetchAllQuestions())
    } catch (error) {
        console.log(error)
    }
}

export const voteQuestion = (id,value,userId)=> async (dispatch)=>{
    try {
        console.log({id,value,userId})
        const {data} = await api.voteQuestion(id,value,userId)
        dispatch(fetchAllQuestions())
    } catch (error) {
        console.log(error)
    }
}

export const postComment = (commentData)=>async (dispatch)=>{
    try {
        const {id,commentBody,userCommented,userId,answerId}=commentData;
        console.log({id,commentBody,userCommented,userId,answerId})
        const {data}=await api.postComment(id,commentBody,userCommented,userId,answerId)
        console.log(data);
        dispatch({type:"POST_COMMENT",payload:data})
        dispatch(fetchAllQuestions())
    } catch (error) {
        console.log(error);
    }
}

export const selectTag = (tagData,navigate) => async (dispatch)=>{
    try {
        console.log(tagData)
        const {data}=await api.tagData(tagData);
        console.log(data)
        dispatch({type:"FETCH_TAGGED_QUESTIONS",payload:data})
        navigate("/Questions")
    } catch (error) {
        console.log(error)
    }
}
